import React from 'react';
import { BookOpenIcon, GiftIcon, SmartphoneIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustStrip } from './TrustStrip';
import { HERO_SUB, MAIN_MOCKUP } from '../data/breakFreeContent';
const INDICATORS = [{
  Icon: ZapIcon,
  label: 'Instant access'
}, {
  Icon: SmartphoneIcon,
  label: '100% Digital'
}];
export function Hero() {
  return <header className="w-full bg-charcoal-950" data-id="element-88" data-mp="1297cu5rar3ad">
      <div className="mx-auto flex min-h-[100svh] max-w-6xl flex-col px-5 pb-5 pt-4 text-center lg:grid lg:min-h-0 lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_auto] lg:items-center lg:gap-x-14 lg:py-14 lg:text-left" data-id="element-89" data-mp="128yye9fizpx2">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-90" data-mp="sde30u4ypnwa">
          <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-91" data-mp="nbewjbdxeav4">
            Redondoland
          </p>
          <h1 className="mt-2.5 font-display text-[1.5rem] font-semibold uppercase leading-[1.1] text-ivory-50 sm:text-4xl lg:mt-4 lg:text-[3.1rem]" data-id="element-92" data-mp="3czflm08u696k">
            You know this relationship is hurting you.
          </h1>
          <p className="mt-1.5 font-display text-[1.1rem] italic leading-snug text-rose sm:text-2xl lg:mt-3 lg:text-3xl" data-id="element-93" data-mp="3o7lvm11r3otp">
            So why does leaving still feel impossible?
          </p>
        </div>

        <img src={MAIN_MOCKUP} alt="The complete BREAK FREE™ system — six volumes and six exclusive bonuses" className="my-2.5 min-h-0 w-full flex-1 object-contain lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:my-0 lg:h-auto" width={1080} height={1350} data-id="element-94" data-mp="3e961rqbca1gi" />

        <div className="lg:col-start-1 lg:row-start-2 lg:self-start" data-id="element-95" data-mp="35a2fkdgvl5xs">
          <p className="mx-auto max-w-md text-[12.5px] leading-snug text-body sm:text-[15px] lg:mx-0 lg:mt-6 lg:max-w-lg lg:leading-relaxed" data-id="element-96" data-mp="2qkwhwtxorns0">
            {HERO_SUB}
          </p>

          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[10px] font-medium uppercase tracking-[0.14em] text-ivory-200 sm:text-[11px] lg:mt-5 lg:justify-start" data-id="element-97" data-mp="2hinbog9gagkf">
            {INDICATORS.map(({
            Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5" data-id="element-98" data-mp="s3umzlkswo5c">
                <Icon className="h-3 w-3 text-champagne" strokeWidth={1.75} aria-hidden="true" data-id="element-99" data-mp="n9qf903poc37" />
                {label}
              </li>)}
          </ul>

          <div className="mt-3.5 flex justify-center lg:mt-6 lg:justify-start" data-id="element-100" data-mp="ddnfu208urjy">
            <CtaButton size="md" label="Yes, I'm ready to break free →" data-id="element-101" data-mp="1b0vupe5qp2cz" />
          </div>
          <TrustStrip className="mt-2.5 lg:mt-4 lg:justify-start" data-id="element-102" data-mp="1ayjh1d70le5q" />
        </div>
      </div>
    </header>;
}